import React, { lazy, Suspense } from 'react';
import Loading from 'components/LoadingIndicator';

const loadable = (importFunc, { fallback = null } = { fallback: null }) => {
  const LazyComponent = lazy(importFunc);

  return props => (
    <Suspense fallback={fallback || <Loading />}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default loadable;
